import { render, staticRenderFns } from "./Anno.vue?vue&type=template&id=638be55e"
import script from "./Anno.vue?vue&type=script&lang=js"
export * from "./Anno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports